export class MatrixSelectionModel {
    Impact: number;
    Likelihood: number;
}